import React from 'react';
import '../css/Tooltip.css'; // Create Tooltip.css for styling

const Tooltip = ({ text, children }) => {
  return (
    <div className="tooltip">
      {children}
      <span className="tooltip-text">{text}</span>
    </div>
  );
};

export default Tooltip;
